import { render, staticRenderFns } from "./CampaignCustomerLimitEditModal.vue?vue&type=template&id=1f1b99a3&scoped=true&"
import script from "./CampaignCustomerLimitEditModal.vue?vue&type=script&lang=ts&"
export * from "./CampaignCustomerLimitEditModal.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignCustomerLimitEditModal.vue?vue&type=style&index=0&id=1f1b99a3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1b99a3",
  null
  
)

export default component.exports